export default "__VITE_ASSET__D42nY$LP__"